var _path, _path2, _circle;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgInstagram = function SvgInstagram(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet",
    ref: ref,
    "aria-labelledby": titleId
  }), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "instagram-gradient",
    cx: "50%",
    cy: "100%",
    r: "150%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#833AB4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "30%",
    style: {
      stopColor: "#C13584"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "60%",
    style: {
      stopColor: "#E1306C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#FD1D1D"
    }
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 1.8c2.67 0 2.987.01 4.04.058 2.71.123 3.78 1.26 3.902 3.902.048 1.054.058 1.37.058 4.04 0 2.67-.01 2.987-.058 4.04-.123 2.64-1.19 3.78-3.902 3.902-1.053.048-1.37.058-4.04.058-2.67 0-2.987-.01-4.04-.058-2.717-.123-3.78-1.26-3.902-3.902C1.81 12.987 1.8 12.67 1.8 10c0-2.67.01-2.987.058-4.04C2.003 3.24 3.28 2.003 6 1.858 7.013 1.81 7.33 1.8 10 1.8zm0-1.8C7.284 0 6.944.012 5.878.06 2.24.227.227 2.24.06 5.878.012 6.944 0 7.284 0 10s.012 3.056.06 4.122c.167 3.638 2.18 5.651 5.818 5.818C6.944 19.988 7.284 20 10 20s3.056-.012 4.122-.06c3.638-.167 5.651-2.18 5.818-5.818C19.988 13.056 20 12.716 20 10s-.012-3.056-.06-4.122C19.773 2.24 17.76.227 14.122.06 13.056.012 12.716 0 10 0z",
    fill: "url(#instagram-gradient)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 4.865a5.135 5.135 0 100 10.27 5.135 5.135 0 000-10.27zm0 8.468a3.333 3.333 0 110-6.666 3.333 3.333 0 010 6.666z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.338,
    cy: 4.662,
    r: 1.2,
    fill: "white"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgInstagram);
var Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;